import { I18nextProvider } from 'react-i18next';
import type { ReactNode } from 'react';
import i18n from './config.js';

/**
 * Thin wrapper around react-i18next's `I18nextProvider`. The provider is
 * already initialized by `./config.js` at module-import time, so this
 * component just hands the same instance down the React tree.
 *
 * Kept as a named export (not the default) so consumers can grep for
 * `I18nProvider` and find the boundary between "i18n setup" and "app code".
 */
export function I18nProvider({ children }: { children: ReactNode }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
